import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Faq} from '../../model/faq';
import {
  FOURTH_FAQ_LABELKEY,
  SECOND_FAQ_LABELKEY,
  standaloneDisneyPlusFaqsConstants,
  standaloneNetflixFaqsConstants, standaloneStreamzBasicFaqsConstants,
  standaloneStreamzFaqsConstants, standaloneStreamzPlusFaqsConstants
} from '../faqs-constants';
import {OmapiIdsUtils} from '../utils/omapi-ids/omapi-ids-utils';
import {OmapiIdConstants} from '../omapi-id-constants';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.less']
})
export class FaqsComponent implements OnInit {

  @Input() omapiId: string;
  @Output() emitOnEnterPressed = new EventEmitter<Faq>();

  faqs: Faq[];

  constructor() {
  }

  ngOnInit() {
    this.faqs = this.getCorrectSetOfFaqs(this.omapiId);
    if (OmapiIdsUtils.NETFLIX_FAQS_PACKS.includes(this.omapiId)) {
      this.enrichSecondFaq();
      this.enrichFourthFaq();
    }
  }

  emitOnEnter(faq: Faq): void {
    this.emitOnEnterPressed.emit(faq);
  }

  private getCorrectSetOfFaqs(omapiId): Faq[] {
    let faqs: Faq[];
    switch (omapiId) {
      case OmapiIdsUtils.DISNEY_PLUS_ID:
        faqs = standaloneDisneyPlusFaqsConstants;
        break;
      case OmapiIdConstants.STREAMZ:
        faqs = standaloneStreamzFaqsConstants;
        break;
      case OmapiIdConstants.STREAMZ_BASIC:
        faqs = standaloneStreamzBasicFaqsConstants;
        break;
      case OmapiIdConstants.RED_CARPET_MORE:
        faqs = standaloneStreamzPlusFaqsConstants;
        break;
      default:
        faqs = standaloneNetflixFaqsConstants;
        break;
    }
    return faqs;
  }

  private enrichSecondFaq(): void {
    const secondFaq = this.faqs.filter(faq => faq.title.startsWith(SECOND_FAQ_LABELKEY)).pop();
    secondFaq.description = SECOND_FAQ_LABELKEY + '.description-' + this.omapiId.toLowerCase();
  }

  private enrichFourthFaq(): void {
    const fourthFaq = this.faqs.filter(faq => faq.title.startsWith(FOURTH_FAQ_LABELKEY)).pop();
    fourthFaq.title = FOURTH_FAQ_LABELKEY + '.title-' + this.omapiId.toLowerCase();
    fourthFaq.description = FOURTH_FAQ_LABELKEY + '.description-' + this.omapiId.toLowerCase();
  }
}
